import { Link } from 'react-router-dom';
import { Phone, Mail, Clock, MapPin } from 'lucide-react';
import LogoIcon from '../Logo';
import { SERVICES } from '../content/services';

export default function Footer() {
  return (
    <footer className="border-t border-steel-100/[0.07] bg-ink-950">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 py-16 md:grid-cols-4 md:px-10">
        <div>
          <div className="flex items-center gap-3">
            <LogoIcon className="h-10 w-10" />
            <span className="font-display text-xl font-medium text-steel-100">
              Revive Builders LLC
            </span>
          </div>
          <p className="mt-4 max-w-xs text-sm font-light leading-relaxed text-steel-400">
            Quality construction with integrity — serving multi-family and commercial
            properties across Central Texas.
          </p>
          <p className="mt-4 text-xs uppercase tracking-widest2 text-steel-500">
            Licensed &amp; Insured
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest2 text-steel-400">Services</h4>
          <div className="mt-5 flex flex-col gap-3 text-sm text-steel-300">
            {SERVICES.map((s) => (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                className="transition-colors hover:text-gold-300"
              >
                {s.name}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest2 text-steel-400">Contact</h4>
          <div className="mt-5 space-y-3 text-sm text-steel-300">
            <a href="tel:+12103931759" className="flex items-center gap-3 transition-colors hover:text-gold-300">
              <Phone className="h-4 w-4 text-gold-400" /> (210) 393-1759
            </a>
            <a href="mailto:mrocha@revivebuildersllc.com" className="flex items-center gap-3 transition-colors hover:text-gold-300">
              <Mail className="h-4 w-4 text-gold-400" /> mrocha@revivebuildersllc.com
            </a>
            <p className="flex items-center gap-3">
              <Clock className="h-4 w-4 text-gold-400" /> Mon – Fri · 8am – 6pm
            </p>
            <p className="flex items-start gap-3">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold-400" />
              San Antonio · Austin · New Braunfels · San Marcos
            </p>
          </div>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest2 text-steel-400">Explore</h4>
          <div className="mt-5 flex flex-col gap-3 text-sm text-steel-300">
            <Link to="/about" className="transition-colors hover:text-gold-300">About</Link>
            <Link to="/#services" className="transition-colors hover:text-gold-300">Services</Link>
            <Link to="/#projects" className="transition-colors hover:text-gold-300">Projects</Link>
            <Link to="/#reviews" className="transition-colors hover:text-gold-300">Reviews</Link>
            <Link to="/contact" className="transition-colors hover:text-gold-300">Request a Bid</Link>
          </div>
        </div>
      </div>
      <div className="border-t border-steel-100/[0.05] py-6 text-center text-xs text-steel-500">
        © {new Date().getFullYear()} Revive Builders LLC. All rights reserved.
      </div>
    </footer>
  );
}
